// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"448":"lg-10","2796":"lg-3","3257":"lg-11","3784":"lg-7","3832":"lg-6","4212":"lg-0","4248":"lg-9","5040":"lg-4","5468":"lg-5","6016":"lg-2","6064":"lg-1","6066":"lg-12","7468":"lg-8"}[chunkId] || chunkId) + ".js";
};